import React, { useEffect, useState, useLayoutEffect } from 'react';
import TablaHistorialIngresado from '../Components/Organisms/TablaHistorialIngresado';
import { ArrowLeftOutlined, FileExcelOutlined } from '@ant-design/icons';
import clienteAxios from '../Utils/clienteAxios';
import ReactHtmlTableToExcel from 'react-html-table-to-excel';
import { useNavigate } from 'react-router-dom';

const HistorialIngresado = () => {
  const [incomeHistory, setIncomeHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useLayoutEffect(() => {
    document.querySelector('.ant-table-content table').id = 'table-to-xls';
  }, []);

  useEffect(() => {
    clienteAxios
      .get(`/caja-chica/information/estimate`)
      .then((response) => {
        let data = response.data.Information;
        data.reverse();
        setIncomeHistory(data);
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  return (
    <>
      <div className="title-content-between">
        <h1 className="mb-2 mr-5">
          <ArrowLeftOutlined className="arrow-size" onClick={() => navigate(-1)} />
          HISTORIAL DE PRESUPUESTO INGRESADO
        </h1>
        <div className="mb-2 flex justify-content-end">
          <ReactHtmlTableToExcel
            id="test-table-xls-button"
            className="download-table-xls-button"
            table="table-to-xls"
            filename="Historial Ingresado"
            sheet="Historial Ingresado"
            buttonText={
              <>
                <FileExcelOutlined className="mr-2" />
                Exportar en Excel
              </>
            }
          />
        </div>
      </div>

      <div className="flex-row flex-wrap mt-1">
        <TablaHistorialIngresado data={incomeHistory} loading={loading} />
      </div>
    </>
  );
};
export default HistorialIngresado;
